import React, { useRef, useState, useEffect } from "react";
import Pagination from "common/pagination";
import { paginationOptions } from "utils/common";
import SelectInput from "common/selectInput";
export const TablePagination = (props) => {
  const { numberOfItems, numberOfPages, currentPageButton, setCurrentPageButton, postsPerPage, setPostsPerPage } =
    props;
  const pageNode = useRef();
  const [arrOfcurrentPageButton, setArrOfcurrentPageButton] = useState([]);
  const changePage = (value) => {
    if (value === -1 && currentPageButton > 1) {
      setCurrentPageButton((prev) => prev - 1);
    } else if (value === 1 && currentPageButton < numberOfPages.length) {
      setCurrentPageButton((prev) => prev + 1);
    }
  };

  const handleResultsPerPage = (e, count) => {
    const value = count?.description ? count.description : 10;
    setPostsPerPage(value);
    setCurrentPageButton(1);
  };
  useEffect(() => {
    let tempNumberOfPages = [...arrOfcurrentPageButton];
    let dotsInitial = "...";
    let dotsLeft = "...";
    let dotsRight = "...";
    if (numberOfPages.length === 0 || numberOfPages.length === 1) {
      tempNumberOfPages = [1];
    } else if (numberOfPages.length === 2) {
      tempNumberOfPages = [1, 2];
    } else if (numberOfPages.length === 3) {
      tempNumberOfPages = [1, 2, 3];
    } else if (numberOfPages.length === 4) {
      tempNumberOfPages = [1, 2, 3, 4];
    } else {
      if (currentPageButton >= 1 && currentPageButton <= 3) {
        tempNumberOfPages = [1, 2, 3, dotsInitial, numberOfPages.length];
      } else if (currentPageButton === 4) {
        const sliced = numberOfPages.slice(0, 4);
        tempNumberOfPages = [...sliced, dotsInitial, numberOfPages.length];
      } else if (currentPageButton > 4 && currentPageButton < numberOfPages.length - 2) {
        const sliced1 = numberOfPages.slice(currentPageButton - 2, currentPageButton);
        const sliced2 = numberOfPages.slice(currentPageButton, currentPageButton + 1);
        tempNumberOfPages = [1, dotsLeft, ...sliced1, ...sliced2, dotsRight, numberOfPages.length];
      } else if (currentPageButton > numberOfPages.length - 3) {
        const sliced = numberOfPages.slice(numberOfPages.length - 4);
        tempNumberOfPages = [1, dotsLeft, ...sliced];
      } else if (currentPageButton === dotsInitial) {
        setCurrentPageButton(arrOfcurrentPageButton[arrOfcurrentPageButton.length - 3] + 1);
      } else if (currentPageButton === dotsRight) {
        setCurrentPageButton(arrOfcurrentPageButton[3] + 2);
      } else if (currentPageButton === dotsLeft) {
        setCurrentPageButton(arrOfcurrentPageButton[3] - 2);
      }
    }
    setArrOfcurrentPageButton(tempNumberOfPages);
  }, [currentPageButton, postsPerPage, numberOfItems]);
  return (
    <div className="section-two border-bottom-0">
      <div className="d-flex search-pagination">
        <div className="pagination__results">
          <div className="d-flex pagination__results__wrapper">
            <div className="pagination__results__heading">Results per page</div>
            <SelectInput
              options={paginationOptions}
              inputRef={pageNode}
              value={postsPerPage}
              showEmptyValue={true}
              type={"__pagination"}
              handleSelectInput={(e, value) => handleResultsPerPage(e, value)}
            />
          </div>
        </div>
        <Pagination
          numberOfPages={numberOfPages}
          setCurrentButton={setCurrentPageButton}
          currentButton={currentPageButton}
          arrOfCurrentButton={arrOfcurrentPageButton}
          handlePrevious={(e) => changePage(-1)}
          handleNext={(e) => changePage(1)}
        />
      </div>
    </div>
  );
};
